import { render, staticRenderFns } from "./ConfirmSignUp.vue?vue&type=template&id=29d87c68&scoped=true&"
import script from "./ConfirmSignUp.vue?vue&type=script&lang=ts&"
export * from "./ConfirmSignUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d87c68",
  null
  
)

export default component.exports